import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getTreatmentEffectivenessReport,
  type TreatmentEffectivenessReportResult,
} from '@services/api/reports/providerPerformance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type TreatmentEffectivenessData = TreatmentEffectivenessReportResult

export type UseTreatmentEffectivenessResult = {
  loading: boolean
  error: string | null
  data: TreatmentEffectivenessData | null
  bucketLabel: string
}

export function useTreatmentEffectiveness(
  toolbarSelection: Record<string, string>,
): UseTreatmentEffectivenessResult {
  const getBucketFromData = useCallback(
    (data: TreatmentEffectivenessReportResult): ReportBucketType =>
      data.totalDiagnosed.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getTreatmentEffectivenessReport,
    getBucketFromData,
    errorMessage: 'Failed to load treatment effectiveness data',
  })
}
